import { cn } from "../lib/utils";

/**
 * The band is 52px - the 11mm the print measures ask for - and so is every clearance kept from
 * it. One measure, written once per role it plays.
 */
const width = "w-[52px]";

/**
 * From lg the footer stops at the band's edge, and the line keeps 48px off it because the corner
 * bulges a radius further left. Below lg there is no band, so the footer pays for its own strip.
 */
export const hatchBandFooterEdge = "pr-[76px] lg:mr-[52px] lg:pr-12";

/**
 * What a content column that would otherwise run under the fixed band puts between itself and
 * it. Exported rather than written out at the call site so the two widths cannot drift.
 */
export const hatchBandInset = "lg:pr-[52px]";

/**
 * The huisstijl's only decorative pattern. Hidden below lg, where the content column reaches the
 * viewport edge it is fixed to; a phone gets {@link HatchBandOverFooter} instead. `z-10` matches
 * the sticky headers, which are opaque and come later, so the band passes behind them.
 */
export function HatchBand({ className }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={cn(
        "jb-hatch-band pointer-events-none fixed inset-y-0 right-0 z-10 hidden lg:block",
        width,
        className,
      )}
    />
  );
}

/**
 * Square, the band and footer meet in a notch; the sheet curves away instead, and this is that
 * arc (`jb-hatch-corner` in `index.css`). Only from lg, where there is a band to turn.
 */
export function HatchBandCorner() {
  return (
    <div
      aria-hidden
      className="jb-hatch-band jb-hatch-corner pointer-events-none absolute right-0 hidden lg:block"
    />
  );
}

/**
 * Over the footer there is no content column to collide with, so the pattern survives on a phone
 * as the footer's own strip. `lg:hidden`, or it would be the same band drawn twice.
 */
export function HatchBandOverFooter() {
  return (
    <div
      aria-hidden
      className={cn(
        "jb-hatch-band pointer-events-none absolute inset-y-0 right-0 lg:hidden",
        width,
      )}
    />
  );
}
